<script>
	import { navigate, useLocation } from "svelte-routing";
	import { Breadcrumb, BreadcrumbItem } from "@sveltestrap/sveltestrap";

	const location = useLocation();

	function formatPath(index) {
		const segments = $location.pathname.split("/").slice(0, index + 2);
		return segments
			.map((s) => s.toLowerCase().split("-").join("-"))
			.join("/");
	}

	const breadcrumbOverrides = {
		"/carpark-management/create": "Add new car park",
	};

	function capitalizeFirstLetter(str) {
		let string = str.split("/details")[0];
		string = string.split("-").join(" ");
		string = string.substring(1);
		string = string.split("/");
		if (string.length !== 1) {
			string = string.map((val) => {
				const titled = toTitleCase(val);
				return titled === "Carpark Management"
					? "Car park management"
					: titled;
			});
			if (breadcrumbOverrides[str]) {
				string[string.length - 1] = breadcrumbOverrides[str];
			}
			return string;
		} else {
			return [];
		}
	}

	const toTitleCase = (str) =>
		str.replace(
			/(^\w|\s\w)(\S*)/g,
			(_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
		);

	const blankMenus = [
		"Master Data",
		"Job Management",
		"Issue Management",
		"Edit Rule",
		"Edit",
		"Maintenance & Repairs",
	];

	$: isIssues = $location.pathname.includes("issues");
	// MaintenanceRepairTabs.svelte renders its own CustomBreadcrumb for this
	// page — suppress the auto-generated one here to avoid showing both.
	$: isVehicleIssues = /^\/maintenance-repair\/[^/]+/.test(
		$location.pathname
	);
</script>

<div class="breadcrumb-container">
	<Breadcrumb>
		{#if !isIssues && !isVehicleIssues}
			{#each capitalizeFirstLetter($location.pathname) as path, index}
				{#if !blankMenus.find((val) => val === path)}
					{#if index < capitalizeFirstLetter($location.pathname).length - 1}
						<BreadcrumbItem>
							<!-- svelte-ignore a11y-invalid-attribute -->
							<a
								href="#"
								class="link"
								on:click={(event) => {
									event.preventDefault();
									navigate(formatPath(index));
								}}><span class="link link-text">{path}</span></a
							>
						</BreadcrumbItem>
					{:else if isNaN(path)}
						<BreadcrumbItem>
							{path}
						</BreadcrumbItem>
					{:else}{/if}
				{:else}
					<BreadcrumbItem>
						{path}
					</BreadcrumbItem>
				{/if}
			{/each}
		{/if}
	</Breadcrumb>
</div>
